import { useEffect, useState } from "react";
import client from "@/lib/api";
import Seo from "@/components/Seo";
import Ticker from "@/components/Ticker";
import StrainCard from "@/components/StrainCard";
import { FadeUp } from "@/components/Reveal";

const TYPES = [
  { key: "all", label: "All Types" },
  { key: "indica", label: "Indica" },
  { key: "sativa", label: "Sativa" },
  { key: "hybrid", label: "Hybrid" },
];
const AVAIL = [
  { key: "all", label: "All" },
  { key: "AVAILABLE", label: "Available" },
  { key: "LIMITED", label: "Limited" },
  { key: "DROPPING_SOON", label: "Dropping Soon" },
  { key: "SOLD_OUT", label: "Sold Out" },
];

export default function Strains() {
  const [strains, setStrains] = useState([]);
  const [type, setType] = useState("all");
  const [status, setStatus] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (type !== "all") params.type = type;
    if (status !== "all") params.status = status;
    client
      .get("/strains", { params })
      .then(({ data }) => setStrains(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [type, status]);

  return (
    <>
      <Seo title="Strains — YAZA EXOTICS Genetics Library" description="Explore the YAZA genetics library — exotic hybrids, indicas and sativas." />

      <section className="mx-auto max-w-[1600px] px-5 pt-16 pb-8 md:px-10 md:pt-24">
        <FadeUp>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.3em] text-yaza-accent">Genetics Library</p>
          <h1 className="font-display text-6xl leading-none md:text-8xl">THE STRAINS</h1>
        </FadeUp>
      </section>

      <Ticker text="GENETICS" speed={60} accent />

      <section className="mx-auto max-w-[1600px] px-5 py-12 md:px-10 md:py-16">
        <div className="mb-4 flex flex-wrap gap-3" data-testid="type-filters">
          {TYPES.map((f) => (
            <button
              key={f.key}
              onClick={() => setType(f.key)}
              data-testid={`type-${f.key}`}
              className={`rounded-none border px-5 py-2 text-xs font-semibold uppercase tracking-widest transition-colors ${
                type === f.key ? "border-yaza-accent bg-yaza-accent text-black" : "border-yaza-border text-white hover:border-yaza-accent"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
        <div className="mb-10 flex flex-wrap gap-3" data-testid="avail-filters">
          {AVAIL.map((f) => (
            <button
              key={f.key}
              onClick={() => setStatus(f.key)}
              data-testid={`avail-${f.key}`}
              className={`rounded-none border px-4 py-1.5 text-[11px] uppercase tracking-widest transition-colors ${
                status === f.key ? "border-white bg-white text-black" : "border-yaza-border text-yaza-dim hover:border-white hover:text-white"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <p className="text-yaza-dim">Loading genetics…</p>
        ) : strains.length === 0 ? (
          <p className="text-yaza-dim" data-testid="no-strains">No strains match these filters.</p>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {strains.map((s, i) => (
              <StrainCard key={s.id} strain={s} index={i} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}
